module.exports = __webpack_public_path__ + "img/nivel-prata.18a77b10.svg";